'use es6';

export const FATAL = 'FATAL';
export const WARNING = 'WARNING';